/**
 * Get the WebSocket server URL based on the current environment
 */
export function getWebSocketUrl(): string {
  // In development (localhost), connect to local backend
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'ws://localhost:3001';
  }

  // In production, connect to the Cloudflare Tunnel (secure WebSocket)
  return 'wss://sessions-steven-johns-advertising.trycloudflare.com';
}
